// agriflow/assets/js/common/DesignationNumber.js

export default function designationNumber(callback, formId) {
    const form = document.getElementById(formId);
    if (form) {
        callback(form);
        return;
    }
    const observer = new MutationObserver((mutations, obs) => {
        const foundForm = document.getElementById(formId);
        if (foundForm) {
            obs.disconnect();
            callback(foundForm);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}